import { collection, deleteDoc, doc, getDoc, getDocs, updateDoc, setDoc } from 'firebase/firestore';
import { db } from '../config/firebase';

const getAll = async () => {
  const snapshot = await getDocs(collection(db, 'users'));
  return snapshot.docs.map((doc) => ({ id: doc.id, ...doc.data() }));
};

const get = async (id) => {
  const docSnap = await getDoc(doc(db, 'users', id));
  return docSnap.exists() ? { id: docSnap.id, ...docSnap.data() } : {};
};

const remove = async (id) => {
  await deleteDoc(doc(db, 'users', id));
};

const edit = async (id, data) => {
  await updateDoc(doc(db, 'users', id), {
    ...data,
  });
};

const add = async (data) => {
  await setDoc(doc(db, 'users', data.id), {
    ...data,
  });
  return data;
};

const funcs = {
  getAll,
  get,
  add,
  edit,
  remove,
};

export default funcs;
